/* eslint-disable id-blacklist */
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { ColumnType } from 'app/shared/utils/column-type.util';
import { preCopyScriptMetadata } from '../consts/metadata-consts';
import { format } from 'app/shared/utils/string.util';
import { ControlMetadata } from 'app/extensibility/metadatas/control/control-metadata';
import { getConnectorV1Name, getConnectorV2Name } from 'shell-models-lib';

export function getExportSettingsControl(isEnabled: boolean = false): ControlMetadata {
    return {
        type: 'import-export-settings',
        bind: 'exportSettings',
        connectionName: stringResources.Snowflake_DisplayText,
        copyOptionsLink: 'https://aka.ms/snowflake-source-copy-options',
        formatOptionsLink: 'https://aka.ms/snowflake-source-format-options',
        supportStorageIntegration: isEnabled
    };
}

export function getImportSettingsControls(isEnabled: boolean = false): ControlMetadata {
    return {
        type: 'import-export-settings',
        bind: 'importSettings',
        connectionName: stringResources.Snowflake_DisplayText,
        copyOptionsLink: 'https://aka.ms/snowflake-sink-copy-options',
        formatOptionsLink: 'https://aka.ms/snowflake-sink-format-options',
        supportStorageIntegration: isEnabled
    }
}

export const snowflakeTableMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.snowflake.datasetType,
    displayName: getConnectorV1Name(stringResources.Snowflake_DisplayText),
    supportLinkedServiceTypes: [adfModelTypeMap.snowflake.linkedServiceType],
    isSource: true,
    isSink: true,
    disabled: __IS_FABRIC_DPE__,
    warningMessage: format(
        stringResources.Connector_Legacy_IsNotSupportedWarning_alt2,
        stringResources.DatasetLowerCase,
        getConnectorV2Name(stringResources.Snowflake_DisplayText)
    ), 
    warningMessageHyperlink: 'https://learn.microsoft.com/azure/data-factory/connector-snowflake?tabs=data-factory',
    notSupportTypeConversion: true,
    supportTypeConversionWhenStaging: __IS_FABRIC_DPE__,
    supportDataFlowWriteComplexStructure: true,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-SnowFlake'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    supportDataFlowSource: true,
    supportDataFlowSink: true,
    splitTablePath: true,
    category: ['Database'],
    notSupportAdditionalColumns: true,
    copySourceControls: [
        getExportSettingsControl()
    ],
    copySinkControls: [
        preCopyScriptMetadata(),
        getImportSettingsControls()
    ],
    PhysicalToLogicalMapping: {
        number: ColumnType.Int64,
        float: ColumnType.Double,
        varchar: ColumnType.String,
        binary: ColumnType.ByteArray,
        boolean: ColumnType.Boolean,
        date: ColumnType.DateTime,
        timestamp_ntz: ColumnType.DateTime,
        time: ColumnType.TimeSpan,
        timestamp_ltz: ColumnType.DateTime,
        timestamp_tz: ColumnType.DateTime
    }
};
